import { Inject, Injectable, InjectionToken } from '@angular/core';
import { QuotesApi } from '@idealsupply/ngclient-webservice-quotes';
import { CurrentCustomerStore } from 'customers-data';
import { AuthenticationService } from 'authentication-data';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { QuoteItem } from './QuoteItem';
import { PunchoutUser } from 'punchout-data';

export const REQUEST_QUOTE_BASE_PATH = new InjectionToken<string>('REQUEST_QUOTE_BASE_PATH', {
  factory: () => {
    return 'https://api.idealsupply.com/messaging/v0';
  },
});
export const REQUEST_QUOTE_MESSAGE_GROUP_ID = new InjectionToken<string>('REQUEST_QUOTE_MESSAGE_GROUP_ID');

@Injectable({
  providedIn: 'root',
})
export class QuotesService {
  constructor(
    private readonly quotesApi: QuotesApi,
    private readonly customerStore: CurrentCustomerStore,
    private readonly authenticationService: AuthenticationService,
    private readonly httpClient: HttpClient,
    @Inject(REQUEST_QUOTE_BASE_PATH) private readonly basePath: string,
    @Inject(REQUEST_QUOTE_MESSAGE_GROUP_ID) private readonly messageGroupId: string,
  ) {}

  public search(
    customerNumber?: string,
    customerPo?: string,
    quoteNumber?: number,
    lineCode?: string,
    partNumber?: string,
    active?: boolean,
    skip?: number,
    limit?: number,
  ) {
    return this.quotesApi.getQuotes(customerNumber, customerPo, quoteNumber, lineCode, partNumber, active, skip, limit);
  }

  public getQuote(quoteId: string) {
    return this.quotesApi.getQuoteById(quoteId);
  }

  public requestQuote(name: string, email: string, message: string, attachments: FileList, items: QuoteItem[]) {
    const formData = new FormData();
    formData.append('name', name);
    formData.append('email', email);
    formData.append('message', message);
    formData.append('accountNumber', this.customerStore.customerNumber() || '');

    if (attachments) {
      for (let i = 0; i < attachments.length; i++) {
        formData.append('attachments', attachments[i]);
      }
    }
    if (items && items.length > 0) {
      let itemIndex = 0;
      for (let i = 0; i < items.length; i++) {
        if (
          !!items[i].description?.trim() ||
          !!items[i].manufacturer?.trim() ||
          !!items[i].partNumber?.trim() ||
          !!items[i].quantity?.trim()
        ) {
          formData.append(`items[${itemIndex}].description`, items[i].description ?? '');
          formData.append(`items[${itemIndex}].manufacturer`, items[i].manufacturer ?? '');
          formData.append(`items[${itemIndex}].partNumber`, items[i].partNumber ?? '');
          formData.append(`items[${itemIndex}].quantity`, items[i].quantity?.toString() ?? '');
          itemIndex++;
        }
      }
    }
    // let headers = new HttpHeaders();
    // headers = headers.set('Authorization', `Bearer ${this.authenticationService.}`);
    return this.httpClient.post<void>(`${this.basePath}/${this.messageGroupId}/request-quote`, formData, {
      // headers,
      withCredentials: true,
    });
  }
}
